module.exports = __webpack_public_path__ + "img/p_4.8f4fb425.jpg";